/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext, useEffect, useState } from 'react';
import ComponenteTables from '../../components/tables/ComponentTables/ComponentTables';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import { cadastro, table } from '../../dados/orcamento/orcamento.dado';
import { useApi } from '../../hooks/userApi';
import React from 'react';
import { formatDinheiro } from 'utils/formatDinheiro';
import { useNavigate } from 'react-router';
import { CarrinhoContext } from 'context/Carrinho/CarrinhoContext';
import { SelectChangeEvent } from '@mui/material';
import { eventManager, UPDATE_EVENTS } from 'utils/eventManager';

const api = useApi();

export default function Orcamento() {
  const {
    loading,
    setLoading,
    loadingMensagem,
    setLoadingMensagem,
    loadingBtn,
    setLoadingBtn,
    loadingAction,
    setLoadingAction,
  }: any = useContext(LoadingContext);
  const { addProdutoCar, clearProdutoCar, addClienteCar }: any = useContext(CarrinhoContext);
  const [orcamento, setOrcamento] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(Number(process.env.REACT_APP_PAGINATION_DEFAULT) || 15);
  const [pageTotal, setPageTotal] = useState(0);
  const [like, setLike] = useState('all');
  const navigate = useNavigate();
  const [allOrcamento, setAllOrcamento] = useState([]);
  const [selectedFilterColumns, setSelectedFilterColumns] = useState<string[]>(
    table.header.filter((column) => !['Duplicar', 'Baixar'].includes(column)),
  );

  const handleLike = (value) => {
    setPage(1);
    setLike(value);
  };
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const getAllOrcamentos = async () => {
    setLoading(true);
    let allData = [];

    try {
      const initialResponse = await api.get(`/orcamento?offset=0&limit=${limit}&like=${like}`);
      if (!initialResponse.status) {
        setLoadingMensagem('Desculpe ocorreu um erro!');
        setLoadingBtn('OK');
        return;
      }

      allData = [...initialResponse.results];
      const totalPages = initialResponse.page_total;

      for (let currentPage = 2; currentPage <= totalPages; currentPage++) {
        const nextPageResponse = await api.get(
          `/orcamento?offset=${limit * (currentPage - 1)}&limit=${limit}&like=${like}`,
        );
        if (!nextPageResponse.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }

        allData = [...allData, ...nextPageResponse.results];
      }

      setLoading(false);
      setPageTotal(totalPages);
      setAllOrcamento(allData);
    } catch (err) {
      const msg = 'Houve um erro interno, tente mais tarde. ' + err.message;
      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  useEffect(() => {
    setLoading(true);
    api
      .get(
        '/orcamento' +
          `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}&filterColumns=${selectedFilterColumns.join(',')}`,
      )
      .then((response) => {
        if (!response.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }
        setLoading(false);
        setOrcamento(response.results);
        setPageTotal(response.page_total);
      })
      .catch((e) => {
        let msg = 'Houve um erro interno, tente mais tarde.' + e.message;
        if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
    getAllOrcamentos();
  }, [page, like, selectedFilterColumns]);

  const handDuplicaOrcamento = (row) => {
    setLoading(true);
    api
      .get('orcamento-produto/orcamento/' + row.id)
      .then((r) => {
        addClienteCar(row.cliente);
        Promise.all(
          r.map((item) => {
            return addProdutoCar(item);
          }),
        ).then(() => {
          navigate('/vendedor/checkout');
        });
      })
      .catch((e) => {
        const msg = 'Houve um erro interno, tente mais tarde.  (' + e.response.status + ')';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  };

  const handchanceOrcamento = (id) => {
    navigate('/vendedor/checkoutPDF/' + id);
  };

  function formataTable(objeto) {
    const novoObjeto = objeto.map((row) => {
      return {
        rowCell: [
          { campo: row.cliente?.nome || '-', onClick: null, link: false },
          { campo: row.cliente?.estado || '-', onClick: null, link: false },
          { campo: row.vendedor?.nome || '-', onClick: null, link: false },
          { campo: new Date(row?.created_at || '').toLocaleDateString('pt-br'), onClick: null, link: false },
          { campo: new Date(row?.validade || '').toLocaleDateString('pt-br'), onClick: null, link: false },
          { campo: row?.cod || '-', onClick: null, link: false },
          { campo: formatDinheiro(row?.precoFinal - row?.descontoFrete || '0'), onClick: null, link: false },
          { campo: row?.status || '-', onClick: null, link: false },
          { campo: 'Duplicar', onClick: () => handDuplicaOrcamento(row), link: true },
          { campo: 'Baixar', onClick: () => handchanceOrcamento(row.id), link: true },
        ],
      };
    });
    return novoObjeto;
  }

  const arrList = {
    header: table.header,
    type: table.type,
    rows: formataTable(orcamento),
  };
  const arrListAll = {
    header: table.header,
    type: table.type,
    rows: formataTable(allOrcamento),
  };

  useEffect(() => {
    const savedColumns = localStorage.getItem('selectedFilterColumns');
    if (savedColumns) {
      const filteredColumns = JSON.parse(savedColumns).filter((column) => table.header.includes(column));
      setSelectedFilterColumns(filteredColumns);
    }
  }, []);

  useEffect(() => {
    const handleVendedorUpdate = (event: CustomEvent) => {
      const currentPath = window.location.pathname;
      if (currentPath.includes('/orcamento')) {
        setLoading(true);
        api
          .get(
            '/orcamento' +
              `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}&filterColumns=${selectedFilterColumns.join(',')}`,
          )
          .then((response) => {
            if (!response.status) {
              setLoadingMensagem('Desculpe ocorreu um erro!');
              setLoadingBtn('OK');
              return;
            }
            setLoading(false);
            setOrcamento(response.results);
            setPageTotal(response.page_total);
          })
          .catch((e) => {
            let msg = 'Houve um erro interno, tente mais tarde.' + e.message;
            if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

            setLoadingMensagem(msg);
            setLoadingBtn('OK');
          });

        getAllOrcamentos();
      }
    };

    eventManager.addEventListener(UPDATE_EVENTS.VENDEDOR_UPDATED, handleVendedorUpdate);

    return () => {
      eventManager.removeEventListener(UPDATE_EVENTS.VENDEDOR_UPDATED, handleVendedorUpdate);
    };
  }, [page, like, selectedFilterColumns, limit]);

  const handleFilterColumnsChange = (event: SelectChangeEvent<string[]>) => {
    const filteredColumns = event.target.value as string[];
    const updatedFilterColumns = filteredColumns.filter(
      (column) => table.header.includes(column) && !['Editar', 'Excluir'].includes(column),
    );
    setSelectedFilterColumns(updatedFilterColumns);
    localStorage.setItem('selectedFilterColumns', JSON.stringify(updatedFilterColumns));
  };

  return (
    <ComponenteTables
      table={arrList}
      cadastro={cadastro}
      pageTotal={pageTotal}
      page={page}
      handleChangePage={handleChangePage}
      handleLike={handleLike}
      allData={arrListAll}
      selectedFilterColumns={selectedFilterColumns}
      handleFilterColumnsChange={handleFilterColumnsChange}
    />
  );
}
